module.exports = __webpack_public_path__ + "media/images/nabor-24-rekre-6536925932909c9586ef9cec312c7c12.jpg";